import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import UsersSidebar from "./UsersSidebar";
import {
  GetUserList,
  GetUserFromDb,
  ChangePassword,
  SaveUser
} from "../../../actions/UserActions";
import { GetSettingsForUser } from "../../../actions/UserSettingActions";
import {
  GetLicenseSummary
} from "../../../actions/LicenseActions";
import { GetRoleList } from "../../../actions/RoleActions";
import { GetUserInRoleForUser } from "../../../actions/UserInRoleAction";
import UserInRoleStore from "../../../stores/UserInRoleStore";
import actionTypes from "../../../actions/ActionTypes";
const UsersView = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const userNameInput = useRef(null);
  const licenseInfo = useSelector((state) => state.licenseInfo.value);
  const roleListInfo = useSelector((state) => state.roleListInfo.value);
  const [currentUser, updateCurrentUser] = useState({});
  const [currentView, updateCurrentView] = useState("roles");
  const [password1, updatePassword1] = useState("");
  const [password2, updatePassword2] = useState("");
  const [passwordError, updatePasswordError] = useState("");
  const [isDirty, updateIsDirty] = useState(false);
  const [tdLicenseSummary, updateTdLicenseSummary] = useState(void 0);
  const [tfLicenseSummary, updateTfLicenseSummary] = useState(void 0);
  const [hasError, updateHasError] = useState(false);
  const [errorMessage, updateErrorMessage] = useState("");
  const [allRoles, updateAllRoles] = useState([]);
  const [busMgrRoles, updateBusMgrRoles] = useState([]);
  const [approverRoles, updateApproverRoles] = useState([]);
  const [viewerRoles, updateViewerRoles] = useState([]);
  const [trinFormsAdminRoles, updateTrinFormsAdminRoles] = useState([]);
  const [trinFormsStandardRoles, updateTrinFormsStandardRoles] = useState([]);
  const [aliasSearchText, updateAliasSearchText] = useState("");
  const [initialLicenseLevel, updateInitialLicenseLevel] = useState("");
  const [hasLicenseCountChanged, updateHasLicenseCountChanged] = useState(false);
  const [invalidLicenseChange, updateInvalidLicenseChange] = useState(false);
  const [newLicenseCount, updateNewLicenseCount] = useState(0);
  const [initialTFLicenseLevel, updateInitialTFLicenseLevel] = useState("");
  const [hasTFLicenseCountChanged, updateHasTFLicenseCountChanged] = useState(false);
  const [invalidTFLicenseChange, updateInvalidTFLicenseChange] = useState(false);
  const [newTFLicenseCount, updateNewTFLicenseCount] = useState(0);
  const [delegatesList, updateDelegatesList] = useState([]);
  const [canDelegateForUserList, updateCanDelegateForUserList] = useState([]);
  const [displayAddDelegateDropdown, updateDisplayAddDelegateDropdown] = useState(false);
  const [displayAddCanDelegateForUserDropdown, updateDisplayAddCanDelegateForUserDropdown] = useState(false);
  const [userList, updateUserList] = useState([]);
  const [newDelegate, updateNewDelegate] = useState({});
  const [newDelegateForUser, updateNewDelegateForUser] = useState({});
  useEffect(() => {
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let userId = parseInt(pathParts[pathParts.length - 1], 10);
    if (userId === 0) {
      console.log("init");
      initNewUser();
    }
    if (userId !== currentUser.userId && userId !== 0) {
      console.log("load1");
      loadUserFromDB();
    }
  }, [location]);
  useEffect(() => {
    if (roleListInfo.loaded === false) {
      console.log("getRoleList");
      GetRoleList(dispatch);
    } else {
      console.log("RoleLoad");
      onRoleLoad(roleListInfo.roleList);
      loadTrinFormsRoles(roleListInfo.trinFormsRoles);
    }
  }, [roleListInfo]);
  useEffect(() => {
    if (licenseInfo.loaded === false) {
      console.log("Lic summ");
      GetLicenseSummary(dispatch);
    } else {
      console.log("Lic Update");
      if (licenseInfo.hasTrinDocsLicense) {
        let ls = licenseInfo.trinDocsLicense;
        const tdLicense = JSON.parse(JSON.stringify(ls));
        tdLicense.sysManagerUsed = ls.sysManagerUsed - 2;
        tdLicense.sysManagerCount = ls.sysManagerCount - 2;
        updateTdLicenseSummary(tdLicense);
      }
      if (licenseInfo.hasTrinFormsLicense) {
        updateTfLicenseSummary(licenseInfo.trinFormsLicense);
      }
    }
  }, [licenseInfo]);
  const initNewUser = () => {
    let newUser = {};
    newUser.licenseLevel = 0;
    newUser.licenseLevelName = "None";
    newUser.licenseStyle = "llbtn-none";
    newUser.userName = "";
    newUser.userId = 0;
    newUser.firstName = "";
    newUser.lastName = "";
    newUser.emailAddress = "";
    newUser.trinFormsLicenseLevel = 0;
    newUser.trinFormsLicenseLevelName = "None";
    newUser.trinFormsLicenseStyle = "llbtn-none";
    newUser.roles = [];
    newUser.isActive = true;
    newUser.isADUser = false;
    newUser.sendEmailNotifications = false;
    updateCurrentUser(newUser);
    userNameInput.current.focus();
  };
  const updateUserInfo = (user) => {
    let newUser = JSON.parse(JSON.stringify(user));
    if (newUser.licenseLevel === 4 || newUser.licenseLevel === 5) {
      newUser.licenseLevelName = "System Manager";
      newUser.licenseStyle = "llbtn-sysadmin";
    }
    if (newUser.licenseLevel === 5) {
      newUser.isPermanant = true;
    } else {
      newUser.isPermanant = false;
    }
    if (newUser.licenseLevel === 3) {
      newUser.licenseLevelName = "Admin";
      newUser.licenseStyle = "llbtn-busadmin";
    }
    if (newUser.licenseLevel === 2) {
      newUser.licenseLevelName = "Approver";
      newUser.licenseStyle = "llbtn-approver";
    }
    if (newUser.licenseLevel === 1) {
      newUser.licenseLevelName = "Viewer";
      newUser.licenseStyle = "llbtn-viewer";
    }
    if (newUser.licenseLevel === 0) {
      newUser.licenseLevelName = "None";
      newUser.licenseStyle = "llbtn-none";
    }
    if (newUser.trinFormsLicenseLevel === 3) {
      newUser.trinFormsLicenseLevelName = "System Manager";
      newUser.trinFormsLicenseStyle = "llbtn-sysAdmin";
    }
    if (newUser.trinFormsLicenseLevel === 2) {
      newUser.trinFormsLicenseLevelName = "Admin";
      newUser.trinFormsLicenseStyle = "llbtn-busadmin";
    }
    if (newUser.trinFormsLicenseLevel === 1) {
      newUser.trinFormsLicenseLevelName = "Standard";
      newUser.trinFormsLicenseStyle = "llbtn-approver";
    }
    if (newUser.trinFormsLicenseLevel === 0) {
      newUser.trinFormsLicenseLevelName = "None";
      newUser.trinFormsLicenseStyle = "llbtn-none";
    }
    updateCurrentUser(newUser);
    updateInitialLicenseLevel(newUser.licenseLevelName);
    updateInitialTFLicenseLevel(newUser.trinFormsLicenseLevelName);
    updateHasError(false);
    updateDelegatesList(user.delegates);
    updateCanDelegateForUserList(user.delegatesForUser);
  };
  const onRoleLoad = (roles) => {
    let allRoles2 = JSON.parse(JSON.stringify(roles));
    let bmRoles = [];
    let appRoles = [];
    let vRoles = [];
    allRoles2.forEach((r) => {
      if (r.licenseLevel === 3) {
        bmRoles.push(r);
      }
      if (r.licenseLevel === 2) {
        appRoles.push(r);
      }
      if (r.licenseLevel === 1) {
        vRoles.push(r);
      }
    });
    updateAllRoles(allRoles2);
    updateBusMgrRoles(bmRoles);
    updateApproverRoles(appRoles);
    updateViewerRoles(vRoles);
  };
  const loadTrinFormsRoles = (tfRoles) => {
    let allRoles2 = JSON.parse(JSON.stringify(tfRoles));
    let admRoles = [];
    let stanRoles = [];
    allRoles2.forEach((r) => {
      if (r.licenseLevel === 2) {
        admRoles.push(r);
      }
      if (r.licenseLevel === 1) {
        stanRoles.push(r);
      }
    });
    updateTrinFormsAdminRoles(admRoles);
    updateTrinFormsStandardRoles(stanRoles);
  };
  const onUserRoleChange = () => {
    let cu = (void 0).state.currentUser;
    cu.roles = [];
    (void 0).setState({ currentUser: cu });
    let action = UserInRoleStore.getLastChange();
    if (action === actionTypes.UserInRoleGetList) {
      let allUserRoles = UserInRoleStore.getUserRoleList();
      allUserRoles.forEach((u) => {
        var result = u.roleId;
        if (result === void 0) {
          return;
        }
        let idx = (void 0).state.currentUser.roles.indexOf(u.roleId);
        if (idx > -1) {
          let newRoles = (void 0).state.currentUser.roles;
          let cu2 = (void 0).state.currentUser;
          newRoles.splice(idx, 1);
          cu2.roles = newRoles;
          (void 0).setState({ currentUser: cu2 });
        } else {
          let cu2 = (void 0).state.currentUser;
          let newRoles = cu2.roles;
          newRoles.push(u.roleId);
          cu2.roles = newRoles;
          (void 0).setState({ currentUser: cu2 });
        }
      });
    }
  };
  const toggleSendEmailNotifications = (e) => {
    const cu = JSON.parse(JSON.stringify(currentUser));
    cu.sendEmailNotifications = e.target.checked;
    updateCurrentUser(cu);
    updateIsDirty(true);
  };
  const setLicenseLevel = (levelId) => {
    let style = "";
    let name = "";
    let currentCount = 0;
    let invalidLicenseChange2 = false;
    switch (levelId) {
      case 4:
        style = "llbtn-sysadmin";
        name = "System Manager";
        currentCount = tdLicenseSummary.sysManagerUsed;
        if (tdLicenseSummary.sysManagerUsed >= tdLicenseSummary.sysManagerCount) {
          invalidLicenseChange2 = true;
        }
        break;
      case 3:
        style = "llbtn-busadmin";
        name = "Admin";
        currentCount = tdLicenseSummary.adminUsed;
        if (tdLicenseSummary.adminUsed >= tdLicenseSummary.adminCount) {
          invalidLicenseChange2 = true;
        }
        break;
      case 2:
        style = "llbtn-approver";
        name = "Approver";
        currentCount = tdLicenseSummary.approverUsed;
        if (tdLicenseSummary.approverUsed >= tdLicenseSummary.approverCount) {
          invalidLicenseChange2 = true;
        }
        break;
      case 1:
        style = "llbtn-viewer";
        name = "Viewer";
        currentCount = tdLicenseSummary.viewerUsed;
        break;
      case 0:
        style = "llbtn-none";
        name = "None";
        break;
      default:
    }
    let cu = currentUser;
    cu.licenseLevel = levelId;
    cu.licenseLevelName = name;
    cu.licenseStyle = style;
    let newCount = currentCount + 1;
    var hasLicenseChanged = true;
    if (name === initialLicenseLevel || name === "Viewer") {
      hasLicenseChanged = false;
    }
    if (levelId === 0) {
      hasLicenseChanged = false;
    }
    updateCurrentUser(cu);
    updateIsDirty(true);
    updateHasLicenseCountChanged(hasLicenseChanged);
    updateNewLicenseCount(newCount);
    updateInvalidLicenseChange(invalidLicenseChange2);
  };
  const setTrinFormsLicenseLevel = (levelId) => {
    let style = "";
    let name = "";
    let currentCount = 0;
    let invalidTFLicenseChange2 = false;
    switch (levelId) {
      case 3:
        style = "llbtn-sysadmin";
        name = "System Manager";
        currentCount = tfLicenseSummary.sysManagerUsed;
        tfLicenseSummary.sysManagerCount++;
        if (tfLicenseSummary.sysManagerUsed >= tfLicenseSummary.sysManagerCount) {
          invalidTFLicenseChange2 = true;
        }
        break;
      case 2:
        style = "llbtn-busadmin";
        name = "Admin";
        currentCount = tfLicenseSummary.adminUsed;
        if (tfLicenseSummary.adminUsed >= tfLicenseSummary.adminCount) {
          invalidTFLicenseChange2 = true;
        }
        break;
      case 1:
        style = "llbtn-approver";
        name = "Standard";
        currentCount = tfLicenseSummary.approverUsed;
        if (tfLicenseSummary.approverUsed >= tfLicenseSummary.approverCount) {
          invalidTFLicenseChange2 = true;
        }
        break;
      case 0:
        style = "llbtn-none";
        name = "None";
        currentCount = tfLicenseSummary.approverUsed;
        break;
      default:
    }
    let cu = currentUser;
    cu.trinFormsLicenseLevel = levelId;
    cu.trinFormsLicenseLevelName = name;
    cu.trinFormsLicenseStyle = style;
    let newCount = currentCount + 1;
    var hasLicenseChanged = true;
    if (name === initialTFLicenseLevel || name === "Viewer") {
      hasLicenseChanged = false;
    }
    if (levelId === 0) {
      hasLicenseChanged = false;
    }
    updateCurrentUser(cu);
    updateIsDirty(true);
    updateHasTFLicenseCountChanged(hasLicenseChanged);
    updateNewTFLicenseCount(newCount);
    updateInvalidTFLicenseChange(invalidTFLicenseChange2);
  };
  const loadUserFromDB = () => {
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let userId = parseInt(pathParts[pathParts.length - 1], 10);
    if (currentUser.userId !== 0 && userId === 0) {
      let newUser = {
        userId: 0,
        userName: "",
        isPermanant: false,
        licenseLevel: 1,
        trinFormsLicenseLevel: 1,
        emailAddress: "",
        licenseLevelName: "Viewer",
        licenseStyle: "llbtn-viewer",
        trinFormsLicenseLevelName: "Viewer",
        trinFormsLicenseStyle: "llbtn-viewer",
        firstName: "",
        lastName: "",
        isActive: true,
        isNew: true,
        isADuser: false,
        roles: []
      };
      updateCurrentUser(newUser);
      updateInitialLicenseLevel(newUser.licenseLevelName);
      updateIsDirty(true);
    } else if (currentUser.userId !== userId) {
      console.log("loading");
      let user = currentUser;
      user.userId = userId;
      updateCurrentUser(user);
      updateIsDirty(false);
      updateHasLicenseCountChanged(false);
      GetUserFromDb(userId, updateUserData);
      GetSettingsForUser(userId, dispatch);
      GetUserInRoleForUser(userId);
    }
  };
  const updateUserData = (user) => {
    console.log(user);
    let userLoad = { ...user.user };
    updateUserInfo(user.user);
  };
  const onChangeUserName = (e) => {
    const cu = JSON.parse(JSON.stringify(currentUser));
    cu.userName = e.target.value;
    updateCurrentUser(cu);
    updateIsDirty(true);
  };
  const onChangeFirstName = (e) => {
    const cu = JSON.parse(JSON.stringify(currentUser));
    cu.firstName = e.target.value;
    updateCurrentUser(cu);
    updateIsDirty(true);
  };
  const onChangeLastName = (e) => {
    const cu = JSON.parse(JSON.stringify(currentUser));
    cu.lastName = e.target.value;
    updateCurrentUser(cu);
    updateIsDirty(true);
  };
  const onChangeEmail = (e) => {
    const cu = JSON.parse(JSON.stringify(currentUser));
    cu.emailAddress = e.target.value;
    updateCurrentUser(cu);
    updateIsDirty(true);
  };
  const switchView = (newView) => {
    updateCurrentView(newView);
  };
  const onChangePassword1 = (e) => {
    updatePassword1(e.target.value);
  };
  const onChangePassword2 = (e) => {
    updatePassword2(e.target.value);
  };
  const onSaveClick = () => {
    let cu = currentUser;
    console.log("SaveUser");
    SaveUser(currentUser.userId, {
      userId: cu.userId,
      userName: cu.userName,
      firstName: cu.firstName,
      lastName: cu.lastName,
      emailAddress: cu.emailAddress,
      licenseLevel: cu.licenseLevel,
      trinFormsLicenseLevel: cu.trinFormsLicenseLevel,
      isActive: cu.isActive,
      isADuser: cu.isADuser,
      roles: cu.roles,
      sendEmailNotifications: cu.sendEmailNotifications,
      delegates: cu.delegates,
      delegatesForUser: cu.delegatesForUser
    }, dispatch, afterSave);
  };
  const afterSave = (data) => {
    if (data.startsWith("Error")) {
      updateHasError(true);
      updateErrorMessage(data);
      return;
    }
    updateIsDirty(false);
    updateHasLicenseCountChanged(false);
    GetLicenseSummary(dispatch);
    if (data.startsWith("User Created")) {
      let idx = data.indexOf(":");
      let uid = data.substring(idx + 1);
      navigate(`/Admin/UsersView/${uid}`);
    }
  };
  const isActiveChange = (e) => {
    const cu = JSON.parse(JSON.stringify(currentUser));
    cu.isActive = e.target.checked;
    updateCurrentUser(cu);
    updateIsDirty(true);
  };
  const isADUserChange = (e) => {
    const cu = JSON.parse(JSON.stringify(currentUser));
    cu.isADuser = e.target.checked;
    updateCurrentUser(cu);
    updateIsDirty(true);
  };
  const onChangePasswordClick = () => {
    console.log(currentUser);
    if (password1.length === 0) {
      updatePasswordError("Password is required");
    } else if (password1.length <= 4) {
      updatePasswordError("Password must be greater than four characters");
    } else if (password1 !== password2) {
      updatePasswordError("Passwords don't match");
    } else if (currentUser.userId === 0) {
      updatePasswordError("Must create user account before setting password");
    } else {
      updatePasswordError("");
      ChangePassword(currentUser.userId, password2, dispatch);
    }
  };
  const toggleRolePermission = (role) => {
    let idx = currentUser.roles.indexOf(role.id);
    const cu = JSON.parse(JSON.stringify(currentUser));
    if (idx > -1) {
      const newRoles = JSON.parse(JSON.stringify(currentUser.roles));
      newRoles.splice(idx, 1);
      cu.roles = newRoles;
      updateCurrentUser(cu);
      updateIsDirty(true);
    } else {
      let newRoles = cu.roles;
      newRoles.push(role.id);
      cu.roles = newRoles;
      updateCurrentUser(cu);
      updateIsDirty(true);
    }
  };
  const removeDelegate = (e, delegate) => {
    let idx = delegatesList.findIndex((x) => x.userName === delegate.userName);
    const cu = JSON.parse(JSON.stringify(currentUser));
    if (idx > -1) {
      const newDelegates = JSON.parse(JSON.stringify(currentUser.delegates));
      newDelegates.splice(idx, 1);
      cu.delegates = newDelegates;
      updateCurrentUser(cu);
      updateIsDirty(true);
      updateDelegatesList(newDelegates);
    }
  };
  const removeCanDelegateForUserList = (e, delegate) => {
    let idx = canDelegateForUserList.findIndex((x) => x.userName === delegate.userName);
    const cu = JSON.parse(JSON.stringify(currentUser));
    if (idx > -1) {
      const newDelegates = JSON.parse(JSON.stringify(currentUser.delegatesForUser));
      newDelegates.splice(idx, 1);
      cu.delegatesForUser = newDelegates;
      updateCurrentUser(cu);
      updateIsDirty(true);
      updateCanDelegateForUserList(newDelegates);
    }
  };
  const displayDelegateUserList = () => {
    updateDisplayAddDelegateDropdown(true);
  };
  const displayCanDelegateForUserList = () => {
    updateDisplayAddCanDelegateForUserDropdown(true);
  };
  const addNewDelegate = () => {
    let cu = JSON.parse(JSON.stringify(currentUser));
    let dlcopy = [...delegatesList];
    dlcopy.push(newDelegate);
    updateDelegatesList(dlcopy);
    cu.delegates = dlcopy;
    updateCurrentUser(cu);
    updateNewDelegate({});
    updateDisplayAddDelegateDropdown(false);
    updateIsDirty(true);
  };
  const addNewCanDelegateForUser = () => {
    let dlcopy = [...canDelegateForUserList];
    dlcopy.push(newDelegateForUser);
    updateCanDelegateForUserList(dlcopy);
    let cu = JSON.parse(JSON.stringify(currentUser));
    cu.delegatesForUser = dlcopy;
    updateCurrentUser(cu);
    updateNewDelegate({});
    updateDisplayAddCanDelegateForUserDropdown(false);
    updateIsDirty(true);
  };
  const onChangeNewDelegate = (e) => {
    let user = userList.filter((x) => x.userName === e.target.value);
    let delegate = {
      id: 0,
      userId: currentUser.userId,
      userName: currentUser.userName,
      delegateUserId: user[0].userId,
      delegateUserName: e.target.value
    };
    updateNewDelegate(delegate);
  };
  const onChangeNewCanDelegateForUser = (e) => {
    let user = userList.filter((x) => x.userName === e.target.value);
    let delegate = {
      id: 0,
      userId: user[0].userId,
      userName: e.target.value,
      delegateUserId: currentUser.userId,
      delegateUserName: currentUser.userName
    };
    updateNewDelegateForUser(delegate);
  };
  return /* @__PURE__ */ React.createElement("div", { className: "sidebarLayout d-flex flex-row flex-fill" }, /* @__PURE__ */ React.createElement("div", { className: "sidebar-container" }, /* @__PURE__ */ React.createElement(UsersSidebar, null)), /* @__PURE__ */ React.createElement(
    "div",
    {
      className: "flex-fill",
      style: {
        display: "grid",
        gridTemplateColumns: "650px 1fr",
        gridTemplateRows: "350px 60px 1fr 15px"
      }
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        id: "userInfo",
        className: "card",
        style: { gridColumn: "1", gridRow: "1", margin: "16px" }
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-user" }), " User Info"),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "form-group col-5" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtUserName" }, "Username"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          disabled: currentUser.isPermanant,
          className: `form-control`,
          ref: userNameInput,
          id: "txtUserName",
          value: currentUser.userName,
          onChange: onChangeUserName,
          placeholder: "userName"
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "form-group col-3 me-2" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtUserName" }, "TrinDocs License"), /* @__PURE__ */ React.createElement(Dropdown, null, /* @__PURE__ */ React.createElement(
        Dropdown.Toggle,
        {
          id: "ddLicenseLevel",
          className: currentUser.isPermanant ? "disabled btn-danger" : currentUser.licenseStyle
        },
        currentUser.licenseLevelName
      ), /* @__PURE__ */ React.createElement(Dropdown.Menu, null, /* @__PURE__ */ React.createElement(
        Dropdown.Item,
        {
          href: "",
          onClick: () => setLicenseLevel(0)
        },
        "None"
      ), /* @__PURE__ */ React.createElement(
        Dropdown.Item,
        {
          href: "",
          onClick: () => setLicenseLevel(1)
        },
        "Viewer"
      ), /* @__PURE__ */ React.createElement(
        Dropdown.Item,
        {
          href: "",
          onClick: () => setLicenseLevel(2)
        },
        "Approver"
      ), /* @__PURE__ */ React.createElement(
        Dropdown.Item,
        {
          href: "",
          onClick: () => setLicenseLevel(3)
        },
        "Admin"
      ), /* @__PURE__ */ React.createElement(
        Dropdown.Item,
        {
          href: "",
          onClick: () => setLicenseLevel(4)
        },
        "System Manager"
      ))), hasLicenseCountChanged && /* @__PURE__ */ React.createElement("span", null, "New Count:", " ", /* @__PURE__ */ React.createElement(
        "span",
        {
          style: invalidLicenseChange ? { color: "red" } : {}
        },
        newLicenseCount
      ))), /* @__PURE__ */ React.createElement("div", { className: "form-group col-3" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtUserName" }, "TrinForms License"), /* @__PURE__ */ React.createElement(Dropdown, null, /* @__PURE__ */ React.createElement(
        Dropdown.Toggle,
        {
          id: "ddLicenseLevel",
          className: currentUser.isPermanant ? "disabled btn-danger" : currentUser.trinFormsLicenseStyle
        },
        currentUser.trinFormsLicenseLevelName
      ), /* @__PURE__ */ React.createElement(Dropdown.Menu, null, /* @__PURE__ */ React.createElement(
        Dropdown.Item,
        {
          href: "",
          onClick: () => setTrinFormsLicenseLevel(0)
        },
        "None"
      ), /* @__PURE__ */ React.createElement(
        Dropdown.Item,
        {
          href: "",
          onClick: () => setTrinFormsLicenseLevel(1)
        },
        "Standard"
      ), /* @__PURE__ */ React.createElement(
        Dropdown.Item,
        {
          href: "",
          onClick: () => setTrinFormsLicenseLevel(2)
        },
        "Admin"
      ))), hasTFLicenseCountChanged && /* @__PURE__ */ React.createElement("span", null, "New Count:", " ", /* @__PURE__ */ React.createElement(
        "span",
        {
          style: invalidTFLicenseChange ? { color: "red" } : {}
        },
        newTFLicenseCount
      )))), /* @__PURE__ */ React.createElement("div", { className: "row", style: { marginTop: "16px" } }, /* @__PURE__ */ React.createElement("div", { className: "form-group col-6" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtFirstName" }, "First Name"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          disabled: currentUser.isPermanant,
          className: "form-control",
          id: "txtFirstName",
          value: currentUser.firstName,
          onChange: onChangeFirstName,
          placeholder: "first name"
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "form-group col-6" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtLastName" }, "Last Name"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          disabled: currentUser.isPermanant,
          className: "form-control",
          id: "txtLastName",
          value: currentUser.lastName,
          onChange: onChangeLastName,
          placeholder: "last name"
        }
      ))), /* @__PURE__ */ React.createElement("div", { className: "row", style: { marginTop: "16px" } }, /* @__PURE__ */ React.createElement("div", { className: "form-group col-6" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "txtEmail" }, "Email Address"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          className: "form-control",
          id: "txtEmail",
          value: currentUser.emailAddress,
          onChange: onChangeEmail,
          placeholder: "email address"
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "col-6" }, /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          disabled: currentUser.isPermanant,
          type: "checkbox",
          className: "form-check-input",
          checked: currentUser.isActive,
          onChange: isActiveChange,
          id: "chkActive"
        }
      ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label", htmlFor: "chkActive" }, "Active")), /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          disabled: currentUser.isPermanant,
          type: "checkbox",
          className: "form-check-input",
          checked: currentUser.isADuser,
          onChange: isADUserChange,
          id: "chkIsAD"
        }
      ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label", htmlFor: "chkIsAD" }, "Is AD User")), /* @__PURE__ */ React.createElement("div", { className: "form-check form-switch" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          className: "form-check-input",
          checked: currentUser.sendEmailNotifications,
          onChange: toggleSendEmailNotifications,
          id: "chkActive"
        }
      ), /* @__PURE__ */ React.createElement("label", { className: "form-check-label", htmlFor: "sendEmailNotif" }, "Send email notifications")))))
    ),
    /* @__PURE__ */ React.createElement(
      "div",
      {
        style: {
          gridColumn: "2",
          gridRow: "1",
          margin: "16px",
          width: "500px",
          height: "200px"
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: "card", style: { width: "260px" } }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-balance-scale" }), " TrinDocs License usage"), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, tdLicenseSummary !== void 0 && /* @__PURE__ */ React.createElement("table", null, /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { style: { width: "180px" } }, "System Managers:"), /* @__PURE__ */ React.createElement("td", { style: { textAlign: "right", color: "#349920" } }, /* @__PURE__ */ React.createElement("span", { style: { color: "#349920" } }, tdLicenseSummary.sysManagerUsed), "/", tdLicenseSummary.sysManagerCount)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, "Admin:"), /* @__PURE__ */ React.createElement("td", { style: { textAlign: "right", color: "#349920" } }, tdLicenseSummary.adminUsed, "/", tdLicenseSummary.adminCount)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, "Approvers:"), /* @__PURE__ */ React.createElement("td", { style: { textAlign: "right", color: "#349920" } }, tdLicenseSummary.approverUsed, "/", tdLicenseSummary.approverCount)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, "Viewers:"), /* @__PURE__ */ React.createElement("td", { style: { textAlign: "right", color: "#349920" } }, tdLicenseSummary.viewerUsed, "/\u221E")))))),
      /* @__PURE__ */ React.createElement("div", { className: "card", style: { width: "260px" } }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-balance-scale" }), " TrinForms License usage"), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, tfLicenseSummary !== void 0 && /* @__PURE__ */ React.createElement("table", null, /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", { style: { width: "180px" } }, "Admin:"), /* @__PURE__ */ React.createElement("td", { style: { textAlign: "right", color: "#349920" } }, tfLicenseSummary.adminUsed, "/", tfLicenseSummary.adminCount)), /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("td", null, "Standard Users:"), /* @__PURE__ */ React.createElement("td", { style: { textAlign: "right", color: "#349920" } }, tfLicenseSummary.approverUsed, "/", tfLicenseSummary.approverCount)))), tfLicenseSummary === void 0 && /* @__PURE__ */ React.createElement("div", null, "You do not have an active TrinForms license uploaded"))),
      hasError && /* @__PURE__ */ React.createElement("div", { className: "alert alert-danger alert-dismissible fade show", style: { marginTop: "16px" } }, errorMessage, /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "btn-close",
          "aria-label": "Close",
          onClick: () => updateHasError(false),
          style: { float: "right" }
        }
      ))
    ),
    /* @__PURE__ */ React.createElement(
      "div",
      {
        id: "userPills",
        style: {
          gridColumnStart: "1",
          gridColumnEnd: "3",
          gridRow: "2 / 2",
          margin: "16px"
        }
      },
      /* @__PURE__ */ React.createElement("ul", { className: "nav nav-pills" }, /* @__PURE__ */ React.createElement("li", { className: "nav-item" }, /* @__PURE__ */ React.createElement(
        "span",
        {
          className: `nav-link ${currentView === "roles" ? "active" : ""}`,
          style: { cursor: "pointer" },
          onClick: () => switchView("roles")
        },
        "Roles"
      )), /* @__PURE__ */ React.createElement("li", { className: "nav-item" }, /* @__PURE__ */ React.createElement(
        "span",
        {
          className: `nav-link ${currentView === "password" ? "active" : ""}`,
          style: { cursor: "pointer" },
          onClick: () => switchView("password")
        },
        "Password"
      )), isDirty && /* @__PURE__ */ React.createElement("li", { className: "nav_item" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-success",
          onClick: onSaveClick,
          style: { marginLeft: "30px" },
          disabled: invalidLicenseChange
        },
        /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-save" }),
        " Save Changes"
      )))
    ),
    currentView === "roles" && currentUser.licenseLevel > 0 && currentUser.licenseLevel <= 3 && /* @__PURE__ */ React.createElement(
      "div",
      {
        id: "userRoles",
        className: "card",
        style: {
          gridColumnStart: "1",
          gridColumnEnd: "3",
          gridRow: "3 / 3",
          margin: "16px"
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Roles"),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, currentUser.licenseLevel >= 3 && /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("div", { className: "card" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Admin"), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, busMgrRoles.map((role) => /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "form-check form-switch",
          key: role.id
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "checkbox",
            className: "form-check-input",
            id: `chkRole_${role.id}`,
            checked: currentUser.roles.indexOf(
              role.id
            ) !== -1,
            onChange: () => toggleRolePermission(role)
          }
        ),
        /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "chkAP2"
          },
          role.name
        )
      ))))), currentUser.licenseLevel >= 2 && /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("div", { className: "card" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Approver"), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, approverRoles.map((role) => /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "form-check form-switch",
          key: role.id
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "checkbox",
            className: "form-check-input",
            id: `chkRole_${role.id}`,
            checked: currentUser.roles.indexOf(
              role.id
            ) !== -1,
            onChange: () => toggleRolePermission(role)
          }
        ),
        /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "chkAP2"
          },
          role.name
        )
      ))))), currentUser.licenseLevel >= 1 && /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("div", { className: "card" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Viewer"), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, viewerRoles.map((role) => /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "form-check form-switch",
          key: role.id
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "checkbox",
            className: "form-check-input",
            checked: currentUser.roles.indexOf(
              role.id
            ) !== -1,
            onChange: () => toggleRolePermission(role),
            id: `chkRole_${role.id}`
          }
        ),
        /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "chkAP2"
          },
          role.name
        )
      )))))))
    ),
    currentView === "roles" && currentUser.licenseLevel === 0 && /* @__PURE__ */ React.createElement(
      "div",
      {
        id: "userRoles",
        className: "card",
        style: {
          gridColumnStart: "1",
          gridColumnEnd: "3",
          gridRow: "3 / 3",
          margin: "16px"
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Roles"),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, "This user has not been assigned to a TrinDocs license")
    ),
    currentView === "trinFormsRoles" && currentUser.trinFormsLicenseLevel > 0 && currentUser.trinFormsLicenseLevel <= 2 && /* @__PURE__ */ React.createElement(
      "div",
      {
        id: "userRoles",
        className: "card",
        style: {
          gridColumnStart: "1",
          gridColumnEnd: "3",
          gridRow: "3 / 3",
          margin: "16px"
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Roles"),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, currentUser.licenseLevel >= 3 && /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("div", { className: "card" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Admin"), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, busMgrRoles.map((role) => /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "form-check form-switch",
          key: role.id
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "checkbox",
            className: "form-check-input",
            id: `chkRole_${role.id}`,
            checked: currentUser.roles.indexOf(
              role.id
            ) !== -1,
            onChange: () => toggleRolePermission(role)
          }
        ),
        /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "chkAP2"
          },
          role.name
        )
      ))))), currentUser.trinFormsLicenseLevel >= 2 && /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("div", { className: "card" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Admin"), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, trinFormsAdminRoles.map((role) => /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "form-check form-switch",
          key: role.id
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "checkbox",
            className: "form-check-input",
            id: `chkRole_${role.id}`,
            checked: currentUser.roles.indexOf(
              role.id
            ) !== -1,
            onChange: () => toggleRolePermission(role)
          }
        ),
        /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "chkAP2"
          },
          role.name
        )
      ))))), currentUser.trinFormsLicenseLevel >= 1 && /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("div", { className: "card" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Standard"), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, trinFormsStandardRoles.map((role) => /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "form-check form-switch",
          key: role.id
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "checkbox",
            className: "form-check-input",
            checked: currentUser.roles.indexOf(
              role.id
            ) !== -1,
            onChange: () => toggleRolePermission(role),
            id: `chkRole_${role.id}`
          }
        ),
        /* @__PURE__ */ React.createElement(
          "label",
          {
            className: "form-check-label",
            htmlFor: "chkAP2"
          },
          role.name
        )
      )))))))
    ),
    currentView === "trinFormsRoles" && currentUser.trinFormsLicenseLevel === 0 && /* @__PURE__ */ React.createElement(
      "div",
      {
        id: "userRoles",
        className: "card",
        style: {
          gridColumnStart: "1",
          gridColumnEnd: "3",
          gridRow: "3 / 3",
          margin: "16px"
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Roles"),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, "This user has not been assigned to a TrinForms license")
    ),
    currentView === "delegations" && currentUser.trinFormsLicenseLevel === 0 && /* @__PURE__ */ React.createElement(
      "div",
      {
        id: "Delegations",
        className: "card",
        style: {
          gridColumnStart: "1",
          gridColumnEnd: "3",
          gridRow: "3 / 3",
          margin: "16px"
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "TrinForms Delegations"),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, "This user has not been assigned to a TrinForms license")
    ),
    currentView === "delegations" && currentUser.trinFormsLicenseLevel > 0 && /* @__PURE__ */ React.createElement(
      "div",
      {
        id: "Delegations",
        className: "card",
        style: {
          gridColumnStart: "1",
          gridColumnEnd: "3",
          gridRow: "3 / 3",
          margin: "16px"
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "TrinForms Delegations"),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, currentUser.licenseLevel >= 4 && /* @__PURE__ */ React.createElement("div", null, "System Managers see all aliases"), currentUser.licenseLevel < 4 && /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, "Delegates for ", currentUser.userName, ":"), /* @__PURE__ */ React.createElement("div", { className: "list-group" }, canDelegateForUserList.map((delegate) => /* @__PURE__ */ React.createElement("li", { className: "list-group-item" }, /* @__PURE__ */ React.createElement("span", null, delegate.userName), " ", /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-danger btn-sm",
          style: { float: "right" },
          onClick: (e) => removeCanDelegateForUserList(e, delegate)
        },
        /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-times" })
      )))), !displayAddCanDelegateForUserDropdown && /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-success",
          onClick: displayCanDelegateForUserList
        },
        /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-plus" }),
        "Add Delegate"
      ), displayAddCanDelegateForUserDropdown && /* @__PURE__ */ React.createElement("div", { className: "form-group" }, /* @__PURE__ */ React.createElement("div", { style: { float: "left" }, className: "me-2" }, /* @__PURE__ */ React.createElement(
        "select",
        {
          className: "form-select me-2",
          value: newDelegateForUser.userName,
          onChange: onChangeNewCanDelegateForUser
        },
        userList.map((user) => /* @__PURE__ */ React.createElement("option", { key: user.userId, value: user.userName }, user.userName))
      )), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-success",
          onClick: addNewCanDelegateForUser
        },
        /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-plus" }),
        " Add"
      )))), /* @__PURE__ */ React.createElement("div", { className: "col-4" }, /* @__PURE__ */ React.createElement("label", { className: "form-label" }, currentUser.userName, " can delegate for:"), /* @__PURE__ */ React.createElement("div", { className: "list-group" }, delegatesList.map((delegate) => /* @__PURE__ */ React.createElement("li", { className: "list-group-item" }, /* @__PURE__ */ React.createElement("span", null, delegate.delegateUserName), " ", /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-danger btn-sm",
          style: { float: "right" },
          onClick: (e) => removeDelegate(e, delegate)
        },
        /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-times" })
      )))), !displayAddDelegateDropdown && /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-success",
          onClick: displayDelegateUserList
        },
        /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-plus" }),
        " Add Delegate"
      ), displayAddDelegateDropdown && /* @__PURE__ */ React.createElement("div", { className: "form-group" }, /* @__PURE__ */ React.createElement("div", { style: { float: "left" }, className: "me-2" }, /* @__PURE__ */ React.createElement(
        "select",
        {
          className: "form-select me-2",
          value: newDelegate.delegateUserName,
          onChange: onChangeNewDelegate
        },
        userList.map((user) => /* @__PURE__ */ React.createElement("option", { key: user.userId, value: user.userName }, user.userName))
      )), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "btn btn-success",
          onClick: addNewDelegate
        },
        /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-plus" }),
        " Add"
      ))))))
    ),
    currentView === "password" && /* @__PURE__ */ React.createElement(
      "div",
      {
        id: "Aliases",
        className: "card",
        style: {
          gridColumnStart: "1",
          gridColumnEnd: "3",
          gridRow: "3 / 3",
          margin: "16px"
        }
      },
      /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Change Password"),
      /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "form-group col-6" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "pwdPassword1" }, "New Password"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "password",
          value: password1,
          onChange: onChangePassword1,
          className: "form-control",
          id: "pwdPassword1",
          placeholder: "Password"
        }
      ))), /* @__PURE__ */ React.createElement("div", { className: "row", style: { marginTop: "20px" } }, /* @__PURE__ */ React.createElement("div", { className: "form-group col-6" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "pwdPassword2" }, "Confirm New Password"), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "password",
          value: password2,
          onChange: onChangePassword2,
          className: "form-control",
          id: "pwdPassword2",
          placeholder: "Password"
        }
      ), passwordError.length > 0 && /* @__PURE__ */ React.createElement(
        "div",
        {
          style: { marginTop: "10px" },
          className: "alert alert-danger",
          role: "alert"
        },
        passwordError
      ))), currentUser.userId !== 0 && /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: onChangePasswordClick,
          style: { marginTop: "20px" },
          className: "btn btn-primary"
        },
        "Change Password"
      ))
    )
  ));
};
export default UsersView;
